import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-reference-document-info-dialog',
  templateUrl: './reference-document-info-dialog.component.html',
  styleUrl: './reference-document-info-dialog.component.scss'
})
export class ReferenceDocumentInfoDialogComponent {
  constructor(public dialogRef: MatDialogRef<ReferenceDocumentInfoDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  close(): void {
    this.dialogRef.close();
  }
}
